export const id = "pokerGO::common";
